import React, { Fragment } from "react";
import { ErrorMessage } from "formik";
import FormLabel from "components/form/FormLabel";
import FormInput from "components/form/FormInput";

type PropsType = {
  name: string
  forName?: string
  label?: string | React.ReactNode
  autoComplete?: boolean | string
  type?: string
  className?: string
  inputProps?: any
  required?: boolean
  disabled?: boolean
  formikField?: boolean
  error?: string | null
  placeholder?: string | null
  onChange?: (e: any) => void
  value?: any
  noClassName?: boolean
}

function Input(props: PropsType) {
  const {
    name,
    label,
    autoComplete = false,
    type = "text",
    className = "",
    inputProps = {},
    required = false,
    disabled = false,
    formikField = true,
    error = null,
    placeholder = null,
    noClassName = false,
    forName = ''
  } = props;
  return (
    <div className={`${noClassName ? '' : 'c__input'} ${className} ${disabled ? "-disabled" : ""}`}>
      {label && (
        <FormLabel required={required} htmlFor={forName ? forName : name}>
          {label}
        </FormLabel>
      )}

      <FormInput
        {...inputProps}
        autoComplete={autoComplete}
        disabled={disabled}
        placeholder={placeholder}
        id={forName ? forName : name}
        formikField={formikField}
        type={type}
        name={name}
        {...formikField ? {} : {
          value: props.value,
          onChange: props.onChange
        }}
      />
      {formikField ? (
        <ErrorMessage name={name} component="p" className="error" />
      ) : (
        <Fragment>
          {error && (
            <p className="error">{error}</p>
          )}
        </Fragment>

      )}

    </div>
  );
}

export default Input;

